export const MobileMenuItems = [
    {
        title : "Home",
        url : "/",
        cName : "nav-links",
        icon : "fa-solid fa-house-user"
    },
    {
        title : "Services",
        url : "/services",
        cName : "nav-links",
        icon : "fa-solid fa-briefcase"
    },
    {
        title : "Clients",
        url : "/clients",
        cName : "nav-links",
        icon : "fa-solid fa-handshake"
    },
    {
        title : "Contact",
        url : "/contact",
        cName : "nav-links",
        icon : "fa-solid fa-address-book"
    },
    {
        title: "Switch to Arabic",
        url: "https://fa-trd.com/",
        cName: "nav-links",
        icon: "fa-solid fa-globe"
    },
    {
        title : "",
        url : "tel://00966550870588",
        cName : "nav-links-mobile",
        icon : "fa-solid fa-phone"
    },
]